import * as yup from "yup"
import { t } from "i18next"

const mortgageLoanCalculatorValidations = ({ isFirstHome }) => {
  return yup.object().shape({
    salary: yup
      .number()
      .typeError(t("Monthly Net Salary must be a number"))
      .nullable()
      .transform((value, originalValue) => {
        return originalValue?.toString()?.trim() === "" ? null : value
      })
      .required(t("Monthly Net Salary is required"))
      .min(0, t("Monthly Net Salary cannot be negative")),

    totalLiabilities: yup
      .number()
      .typeError(t("Monthly Obligations must be a number"))
      .nullable()
      .transform((value, originalValue) => (originalValue?.toString()?.trim() === "" ? null : value))
      .required(t("Monthly Obligations is required"))
      .min(0, t("Monthly Obligations cannot be negative")),

    nationalityId: yup.string().required(t("Nationality is required")).nullable(),
    dateOfBirth: yup.mixed().nullable(),
    isFirstHome: yup.boolean().required(t("This is required")).nullable(),
    occupationType: yup.string().nullable(),
    propertyType: yup.string().required(t("Property Type is required")).nullable(),
    projectId: yup.mixed().required(t("Project is required")).nullable(),
    listingId: yup.mixed().required(t("Unit is required")).nullable(),
    unitPrice: yup.number().required(t("Unit Price is required")).nullable(),
    unitType: yup.string().required(t("Unit Type is required")).nullable(),
    interestedCity: yup.string().required(t("City is required")).nullable(),
    preferredUnitConstructionPhase: yup.string().required(t("Construction Phase is required")).nullable(),
    updateMortgageProfile: yup.boolean(),
    eligibleMonthlyInstallment: yup.number().nullable(),
    tenor: yup
      .number()
      .min(3, t("Tenor must be at least 3 years"))
      .max(25, t("Tenor cannot exceed 25 years"))
      .nullable(),
    downPayment: yup.object().nullable(),
  })
}

export default mortgageLoanCalculatorValidations
